'use client'
import React, {useState, useCallback, useMemo, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import { toast } from "react-toastify";
import {createPaymentTransaction, createPOSPaymentTransaction} from "../../../redux/paymentTransactionSlice";
import CreditCardFormModal from "../../../components/dejavoo/cardDetailsModal";
import {useCalendarState} from "../hooks/useCalendarState";
import {useQuery} from "../../../utils/useQuery";
import paymentLoadingGif from "app/assets/gifs/loading.gif";
import {selectAccount} from "../../../redux/accountSlice";
import {DualPricingModal} from "../../../components/dualPricingModal/dualPricingModal";
import {DualPricingPaymentTypes} from "../../../sales/useSales";
import PaymentModal from "../ui/PaymentModal";
import {getSalePaymentBalances} from "../../../utils/saleBalances";


type CardOption = "CREDIT_CARD" | "CASH" | "GIFT_CARD" | "MANUAL_ENTRY" | null;

interface PaymentMethodHandlerProps {
    sale: any;
    appointmentClient?: any;
    setAppointmentDrawer: (val: { isOpen: boolean; type: string | null }) => void;
    tax:Number;
    discount: Number;
    updateCalendarData: () => Promise<void> | void;
}

export default function PaymentMethodHandler({
    tax,
                                                 discount,
                                                 sale,
                                                 appointmentClient,
                                                 setAppointmentDrawer,
                                                 updateCalendarData,
                                             }: PaymentMethodHandlerProps) {
    const dispatch = useDispatch();
    const query=useQuery()
    const date=query.get('date')
    const view=query.get('calendarView')
    const employeeId=query.get('employeeId')
    const account = useSelector(selectAccount);

    const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false)


    const {getSchedulesOfEmployees,getWeeklySchedulesOfEmployees,setIsDoingPayment}=useCalendarState()

    const [selectedOption, setSelectedOption] = useState<CardOption>(null);
    const [paymentMethod, setPaymentMethod] = useState<CardOption>(null);
    const [isValidated, setIsValidated] = useState(false);
    const [validationError, setValidationError] = useState<string | null>(null);
    const [cardData, setCardData] = useState<any>(null);

    const [paymentLoading, setPaymentLoading] = useState(false)
    const { remainingCents } = getSalePaymentBalances(sale);

    const handlePaymentSelect = useCallback((option: CardOption) => {
        setSelectedOption(option);
        setPaymentMethod(option)
        setIsValidated(false);
        setValidationError(null);
    }, []);

    const handleAfterValidation = useCallback((res: any) => {
        if (res?.payment_token_id) {
            setCardData(res);
            setIsValidated(true);
            setValidationError(null);
        } else {
            setValidationError(res?.error || "Validation failed");
            setIsValidated(false);
        }
    }, [cardData]);

    const handleCompletePayment = useCallback(() => {
        setCardData(null);
        setIsValidated(false);
        setValidationError(null);
        setSelectedOption(null);
        setPaymentMethod(null)
        setIsDoingPayment(false)
        setAppointmentDrawer({ isOpen: false, type: null });
    }, [setAppointmentDrawer]);

    const handleCloseCardModal = useCallback(() => {
        setSelectedOption(null)

        setCardData(null);
        setIsValidated(false);
        setValidationError(null);
    }, [selectedOption]);


    return (
        <div className={'w-full flex flex-col gap-3 relative px-6'}>

            {remainingCents > 0 ? (
            <button
                disabled={paymentLoading}
                 // onClick={async ()=> await handleCheckOut(sale)}
                 onClick={ ()=> setIsPaymentModalOpen(true)}
                className="px-6 w-full py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold text-lg rounded-lg transition-colors shadow-lg"
            >
                Complete Payment
            </button>
            ) : (
                <p className="w-full py-2 text-center text-sm font-medium text-green-700">Payment complete</p>
            )}

            <PaymentModal
                tax={tax}
                discount={discount}
                updateCalendarData={updateCalendarData}
                sale={sale}
                appointmentClient={appointmentClient}
                open={isPaymentModalOpen}
                onOpenChange={setIsPaymentModalOpen}
                onPaymentSuccess={() => {
                    setIsDoingPayment(false);
                    setAppointmentDrawer({ isOpen: false, type: null });
                }}
            />


        </div>
    );
}
